import React, { useState, useEffect } from "react";
import { MintComic, totalSupply } from "../utils/comics";

const Comic = () => {
  const [supply, setSupply] = useState(0);
  const [amount, setAmount] = useState(1);
  const [loading, setLoading] = useState(false);

  const Subtract = () => {
    if (amount > 1) {
      setAmount(parseInt(amount) - 1);
    }
  };

  const Add = () => {
    if (amount < 30) {
      setAmount(parseInt(amount) + 1);
    }
  };

  const handleChange = (event) => {
    setAmount(event.target.value);
  };

  const mint = async () => {
    setLoading(true);
    await MintComic(amount);
    setLoading(false);
    window.location.reload();
  };

  useEffect(async () => {
    const supply = await totalSupply();
    if (!isNaN(supply)) {
      setSupply(supply);
    }
  }, []);

  return (
    <>
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <section id="minter" className="container minter_container">
        <h2>Mint MonkeyDoo/CMC 🐵 Comic NFTs</h2>
        {supply === 0 ? (
          <p
            style={{
              fontSize: "1.3rem",
            }}
          >
            {" "}
            Connect your Wallet to see Amount Minted
          </p>
        ) : (
          <h5>
            Total Minted: <span> {supply} of 1,000 </span>
          </h5>
        )}
        <div className="progressBar">
          <div
            className="progress"
            style={{
              width: Math.floor((supply / 1000) * (100 / 100) * 100) + "%",
            }}
          ></div>
        </div>
        <div className="mint_value">
          <h5>
            {amount} NFT = {amount * 1} ETC
          </h5>
          <p>0.5 ETC for the Frist 300 Mint</p>
          <p>One Free Mint for MonkeyDoo and CMC Holders</p>
          <p>1 ETC Standard Price</p>
          <h3>Unlimited per transaction</h3>
        </div>
        <div className="mint_section">
          <div className="mint_box">
            <div className="mint">
              <button onClick={() => Subtract()}> - </button>
              {/* <span> {counter}</span> */}
              <input
                value={amount}
                type="number"
                style={{
                  width: "50px",
                  background: "inherit",
                  textAlign: "center",
                }}
                onChange={handleChange}
              />
              {/* onChange={handleChange} */}
              <button onClick={() => Add()}> + </button>
            </div>
          </div>
          <br />

          <div>
            {supply === 3000 ? null : (
              <a
                // className="nav_link button_type free_button alternate"
                // className="nav_link button_type equal_button"
                style={{
                  width: "100px",
                }}
              >
                {loading === true ? (
                  <span>Loading.....</span>
                ) : (
                  // <span>Mint</span>
                  <button className="btn btn-primary" onClick={mint}>
                    Mint Now !
                  </button>
                  // <span className="section_text smaller">
                  //   Minting Coming Soon
                  // </span>
                )}
              </a>
            )}
          </div>

          <h3 className="contract">
            <a
              target="_blank"
              href="https://blockscout.com/etc/mainnet/address/0x3673d02A78a266432f29f80DE511B76957E32a12/transactions"
            >
              View Contract
            </a>
          </h3>

          <h5>
            Please use Chrome/Firefox with metamask extension for PC or metamask
            app for mobile
          </h5>
        </div>
      </section>
    </>
  );
};

export default Comic;
